module.exports = __webpack_public_path__ + "img/floor_OG5.6b5ab759.svg";